import React from "react";
import {
  IconClose,
  IconError,
  IconInfo,
  IconSuccess,
  IconWarning,
} from "../icons";

function DefaultToastIcon({ variant }) {
  if (variant === "success") {
    return <IconSuccess sx={{ fontSize: 16 }} />;
  }

  if (variant === "warning") {
    return <IconWarning sx={{ fontSize: 16 }} />;
  }

  if (variant === "error") {
    return <IconError sx={{ fontSize: 16 }} />;
  }

  return <IconInfo sx={{ fontSize: 16 }} />;
}

export default function AppToast({
  variant = "info",
  title,
  dismissible = true,
  onClose,
  className = "",
}) {
  const classes = ["ds-toast", `ds-toast--${variant}`, className].filter(Boolean).join(" ");
  const liveRole = variant === "error" || variant === "warning" ? "alert" : "status";

  return (
    <section className={classes} role={liveRole} aria-live="polite">
      <div className="ds-toast__icon" aria-hidden="true">
        <DefaultToastIcon variant={variant} />
      </div>

      <div className="ds-toast__body">
        {title ? <div className="ds-toast__title">{title}</div> : null}
      </div>

      {dismissible && typeof onClose === "function" ? (
        <button type="button" className="ds-toast__close" aria-label="Toast schliessen" onClick={onClose}>
          <IconClose sx={{ fontSize: 16 }} />
        </button>
      ) : null}
    </section>
  );
}
